import { render, staticRenderFns } from "./initUser.vue?vue&type=template&id=9c7ce0d2&scoped=true&"
import script from "./initUser.vue?vue&type=script&lang=js&"
export * from "./initUser.vue?vue&type=script&lang=js&"
import style0 from "./initUser.vue?vue&type=style&index=0&id=9c7ce0d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7ce0d2",
  null
  
)

export default component.exports